import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

/**
 * The Info Box Component renders the parent's outlet html in a box.
 * If an edit routerLink is given a link is displayed to route to an edit page
 *
 * @example
 * <ish-info-box heading="checkout.widget.billing-address.heading" editRouterLink="/checkout/address">
 *  <ish-address [address]="basket.invoiceToAddress"></ish-address>
 * </ish-info-box>
 */
@Component({
  selector: 'ish-info-box',
  templateUrl: './info-box.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, RouterLink, FaIconComponent, TranslateModule],
})
export class InfoBoxComponent {
  /**
   * Translation key of the box title (or a title text).
   */
  readonly heading = input<string>(undefined);

  /**
   * Router link for Editing the displayed data. If a routerLink is given a link is displayed to route to an edit page
   */
  readonly editRouterLink = input<string>(undefined);

  /**
   * Additional css classes to be passed to the infobox div
   */
  readonly cssClass = input<string>(undefined);
}
